/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Artifacts_Empty_DescriptionInputs */



/**
* | output |
* | --- |
* | "Artifacts created during chats in this project will appear here." |
*
* @param {Project_Artifacts_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_artifacts_empty_description = /** @type {((inputs?: Project_Artifacts_Empty_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Artifacts_Empty_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Artefakte, die während Chats in diesem Projekt erstellt werden, erscheinen hier.")
	return /** @type {LocalizedString} */ ("Artifacts created during chats in this project will appear here.")
});